import { render, staticRenderFns } from "./pop-certificate-detail.vue?vue&type=template&id=c361898c&scoped=true"
import script from "./pop-certificate-detail.vue?vue&type=script&lang=js"
export * from "./pop-certificate-detail.vue?vue&type=script&lang=js"
import style0 from "./pop-certificate-detail.vue?vue&type=style&index=0&id=c361898c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c361898c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c361898c')) {
      api.createRecord('c361898c', component.options)
    } else {
      api.reload('c361898c', component.options)
    }
    module.hot.accept("./pop-certificate-detail.vue?vue&type=template&id=c361898c&scoped=true", function () {
      api.rerender('c361898c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/certificate/components/pop-certificate-detail.vue"
export default component.exports